export abstract class Store {
  constructor() {}

  setItem(name: string, value: any, params = {}): any {}

  getItem(name: string): any {}

  deleteItem(name: string): any {}

  clear() {}

  length(): any {}

  keys(): any {}
}
